module.exports = __webpack_public_path__ + "static/media/mixed-logo.b5ca9379.png";